import {TranslationTypes} from "./actionTypes";

const initialState = {
    translationListError: null,
    message: null,
    translationList: null,
    isLoadingAddTranslation: false,
    isAddNewTranslationOpen: false,
    query: {
        page: 1,
        pageSize: 20,
        search: ''
    }
}

const translation = (state = initialState, action) => {

    switch (action.type) {
        case TranslationTypes.TRANSLATION_GET:
            state = {
                ...state,
                translationList: null,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_SUCCESSFUL:
            state = {
                ...state,
                translationList: action.payload,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_ERROR:
            state = {
                ...state,
                translationList: null,
                translationListError: action.payload
            }
            break;
        case TranslationTypes.TRANSLATION_GET_TYPE:
            state = {
                ...state,
                translationList: null,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_TYPE_SUCCESSFUL:
            state = {
                ...state,
                translationList: action.payload,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_TYPE_ERROR:
            state = {
                ...state,
                translationList: null,
                translationListError: action.payload
            }
            break;
        case TranslationTypes.TRANSLATION_ADD:
            state = {
                ...state,
                translationList: null,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_ADD_SUCCESSFUL:
            state = {
                ...state,
                translationList: action.payload,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_ADD_ERROR:
            state = {
                ...state,
                translationList: null,
                translationListError: action.payload
            }
            break;
        case TranslationTypes.TRANSLATION_EDIT:
            state = {
                ...state,
                translationList: null,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_EDIT_SUCCESSFUL:
            state = {
                ...state,
                translationList: action.payload,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_EDIT_ERROR:
            state = {
                ...state,
                translationList: null,
                translationListError: action.payload
            }
            break;
        case TranslationTypes.TRANSLATION_REMOVE:
            state = {
                ...state,
                translationList: action.payload,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_REMOVE_SUCCESSFUL:
            state = {
                ...state,
                translationList: action.payload,
                translationListError: null
            }
            break;
        case TranslationTypes.TRANSLATION_REMOVE_ERROR:
            state = {
                ...state,
                translationList: null,
                translationListError: null
            }
            break;
        case TranslationTypes.SET_TRANSLATION_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case TranslationTypes.RESET_TRANSLATION_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default translation;
